import React from "react";
import Activities from "../components/Activities";
import MenuBar from "../components/MenuBar";
import Page from "../components/Page";
import { PageRoutes } from "../utils/routes";
import ConstantActivities from "../components/ConstantActivities";

const Program = () => {
  return (
    <>
      <Page>
        <MenuBar selectedKey={PageRoutes.Program} />
        <Activities />
        <ConstantActivities />
      </Page>
    </>
  );
};

export default Program;
